/* DTR product page: size finder drawer + "complete the kit".
   Loaded with defer, only on templates that use these blocks. No dependencies. */
(() => {
  if (window.__dtrPdp) return;
  window.__dtrPdp = true;

  // Shared tabbed side panel (snippets/dtr-info-panel.liquid): size finder,
  // reviews, description, care, ... Triggers are [data-dtr-tab="<id>"] buttons.
  let lastTrigger = null;
  const reviewsSection = () => document.querySelector('[id$="__dtr_reviews"]');
  const getPanel = () => {
    // The theme re-renders the product info on variant change and delivers a
    // fresh copy of the panel; keep the first one (moved to <body>, holds the
    // size finder state and the reviews) and drop the copies.
    const all = [...document.querySelectorAll('#dtr-info-panel')];
    if (!all.length) return null;
    const panel = all.find((p) => p.parentElement === document.body) || all[0];
    if (panel.parentElement !== document.body) document.body.appendChild(panel);
    all.forEach((p) => { if (p !== panel) p.remove(); });
    if (!panel._ready) {
      panel._ready = true;
      const rev = panel.querySelector('[data-dtr-tab-btn="reviews"]');
      if (rev && reviewsSection() && document.documentElement.classList.contains('dtr-rev-ok')) rev.hidden = false;
      panel.addEventListener('close', () => {
        if (lastTrigger && lastTrigger.isConnected) lastTrigger.focus();
        else { const t = document.querySelector('[data-dtr-tab]'); if (t) t.focus(); }
      });
      panel.addEventListener('keydown', (e) => {
        const tab = e.target.closest('[role="tab"]');
        if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
        const tabs = [...panel.querySelectorAll('[role="tab"]:not([hidden]):not([data-dtr-off])')];
        let i = tabs.indexOf(tab);
        if (e.key === 'ArrowRight') i = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') i = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') i = 0; else i = tabs.length - 1;
        e.preventDefault();
        activateTab(panel, tabs[i].dataset.dtrTabBtn);
        tabs[i].focus();
      });
    }
    return panel;
  };
  const activateTab = (panel, id) => {
    const tabs = [...panel.querySelectorAll('[role="tab"]')];
    if (!tabs.some((b) => b.dataset.dtrTabBtn === id && !b.hidden)) id = tabs.find((b) => !b.hidden)?.dataset.dtrTabBtn;
    // Scope the visible tabs to the group (size / reviews / info) of the opened tab; a group with a single
    // tab shows no tab bar, just that tab as the panel title.
    const target = tabs.find((b) => b.dataset.dtrTabBtn === id);
    const group = target?.dataset.dtrGroup;
    if (group) {
      tabs.forEach((b) => { if (b.dataset.dtrGroup === group) b.removeAttribute('data-dtr-off'); else b.setAttribute('data-dtr-off', ''); });
      panel.querySelector('.dtr-pdp-tabs')?.classList.toggle('dtr-pdp-tabs--solo', tabs.filter((b) => !b.hidden && !b.hasAttribute('data-dtr-off')).length < 2);
    }
    if (id === 'reviews') {
      const body = panel.querySelector('[data-dtr-tab-panel="reviews"]');
      const section = reviewsSection();
      if (body && section && !body.contains(section)) { body.appendChild(section); section.classList.add('is-in-panel'); }
    }
    tabs.forEach((b) => {
      const on = b.dataset.dtrTabBtn === id;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
      if (on) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
    panel.querySelectorAll('[role="tabpanel"]').forEach((p) => { p.hidden = p.dataset.dtrTabPanel !== id; });
    const body = panel.querySelector('.dtr-pdp-drawer__body');
    if (body) body.scrollTop = 0;
  };
  const openPanel = (id, trigger) => {
    const panel = getPanel();
    if (!panel) return false;
    lastTrigger = trigger || document.activeElement;
    activateTab(panel, id);
    if (!panel.open) panel.showModal();
    panel.querySelector('[aria-selected="true"]')?.scrollIntoView({ block: 'nearest', inline: 'center' });
    return true;
  };

  // Open / close drawers (native <dialog>). Delegated so it survives the
  // theme re-rendering the product info on variant change.
  document.addEventListener('click', (e) => {
    const inlineOpener = e.target.closest('[data-dtr-inline-open]');
    if (inlineOpener) {
      const target = document.getElementById(inlineOpener.getAttribute('href').slice(1));
      if (target) {
        e.preventDefault();
        target.open = true;
        target.querySelector('summary')?.setAttribute('aria-expanded', 'true');
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
    const tabBtn = e.target.closest('[role="tab"][data-dtr-tab-btn]');
    if (tabBtn) { activateTab(tabBtn.closest('dialog'), tabBtn.dataset.dtrTabBtn); return; }
    const tabOpener = e.target.closest('[data-dtr-tab]');
    if (tabOpener) { openPanel(tabOpener.dataset.dtrTab, tabOpener); return; }
    const opener = e.target.closest('[data-dtr-open]');
    if (opener) {
      const d = document.getElementById(opener.dataset.dtrOpen);
      if (d && !d.open) d.showModal();
      return;
    }
    if (e.target.closest('[data-dtr-close]')) e.target.closest('dialog')?.close();
    else if (e.target.matches('dialog.dtr-pdp-drawer')) e.target.close(); // click on backdrop
  });
  document.addEventListener('toggle', (e) => {
    if (!e.target.matches('.dtr-pdp-inline-details')) return;
    e.target.querySelector('summary')?.setAttribute('aria-expanded', e.target.open ? 'true' : 'false');
    // One row open at a time (fallback for browsers without <details name>).
    if (e.target.open) document.querySelectorAll('.dtr-pdp-inline-details[open]').forEach((d) => { if (d !== e.target) d.open = false; });
  }, true);

  const norm = (s) => String(s).trim().toUpperCase().replace(/^2XL$/, 'XXL').replace(/^3XL$/, 'XXXL');

  class SizeFinder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return; // moved between containers: keep the listeners already attached
      this._ready = true;
      this.rows = [...this.querySelectorAll('tr[data-size]')].map((tr) => {
        const [h0, h1] = tr.dataset.h.split(',').map(Number);
        const [w0, w1] = tr.dataset.w.split(',').map(Number);
        return { size: tr.dataset.size, h: [h0, h1], w: [w0, w1], tr };
      });
      this.h = this.querySelector('[data-height]');
      this.w = this.querySelector('[data-weight]');
      this.out = this.querySelector('[data-result]');
      const run = () => this.recommend();
      this.h.addEventListener('input', run);
      this.w.addEventListener('input', run);
      this.querySelectorAll('[data-fit]').forEach((r) => r.addEventListener('change', run));
      this.out.addEventListener('click', (e) => {
        const b = e.target.closest('[data-use]');
        if (b) { this.selectSize(b.dataset.use); this.closest('dialog')?.close(); }
      });
    }

    // Same idea as the Lovable fit finder: sizes whose height AND weight range
    // contain the rider, ranked by distance to the middle of each range. Two
    // close matches = "between sizes". No match = nearest size, flagged.
    recommend() {
      const h = +this.h.value, w = +this.w.value;
      this.rows.forEach((r) => r.tr.classList.remove('is-match'));
      if (!(h >= 120 && h <= 230 && w >= 30 && w <= 200)) {
        this.out.innerHTML = `<p class="dtr-pdp-muted">${this.dataset.empty}</p>`;
        return;
      }
      const span = (a) => Math.max(a[1] - a[0], 1);
      const score = (r) => Math.abs(h - (r.h[0] + r.h[1]) / 2) / span(r.h) + Math.abs(w - (r.w[0] + r.w[1]) / 2) / span(r.w);
      const inside = this.rows.filter((r) => h >= r.h[0] && h <= r.h[1] && w >= r.w[0] && w <= r.w[1]);
      let picks, closest = false;
      if (inside.length) {
        picks = inside.sort((a, b) => score(a) - score(b)).slice(0, 2);
        if (picks.length === 2 && score(picks[1]) - score(picks[0]) > 0.35) picks = [picks[0]];
        picks.sort((a, b) => this.rows.indexOf(a) - this.rows.indexOf(b));
      } else {
        const dist = (r) => Math.max(0, r.h[0] - h, h - r.h[1]) / 40 + Math.max(0, r.w[0] - w, w - r.w[1]) / 60;
        picks = [[...this.rows].sort((a, b) => dist(a) - dist(b))[0]];
        closest = true;
      }
      // Vest / windbreaker / base layer: race fit = one size down from the jersey size.
      if (this.querySelector('[data-fit][value="race"]:checked')) {
        picks = [...new Set(picks.map((r) => this.rows[Math.max(0, this.rows.indexOf(r) - 1)]))];
      }
      picks.forEach((r) => r.tr.classList.add('is-match'));
      const label = picks.map((r) => r.size).join(' / ');
      const note = picks.length === 2 ? this.dataset.between : closest ? this.dataset.closest : '';
      // Only offer "Select" for sizes in stock; say so for sold-out ones.
      const stock = (this.dataset.inStock || '').split('|').filter(Boolean).map(norm);
      const known = this.dataset.sizePosition !== ''; // no size option found = no stock info
      const inStock = (size) => !known || stock.includes(norm(size));
      const buttons = picks.filter((r) => inStock(r.size)).map((r) => `<button type="button" class="button button--sm" data-use="${r.size}">${this.dataset.select.replace('[size]', r.size)}</button>`).join(' ');
      const soldOut = picks.filter((r) => !inStock(r.size)).map((r) => `<p class="dtr-pdp-small">${this.dataset.soldOut.replace('[size]', r.size)}</p>`).join('');
      this.out.innerHTML = `<span class="dtr-pdp-finder__size">${label}</span>${note ? `<p class="dtr-pdp-small">${note}</p>` : ''}${soldOut}<div>${buttons}</div>`;
    }

    // Tick the matching size in the theme's own variant picker.
    selectSize(size) {
      const form = this.dataset.form, pos = this.dataset.sizePosition;
      const inputs = document.querySelectorAll(`input[type=radio][form="${form}"]${pos ? `[name="option${pos}"]` : ''}`);
      for (const input of inputs) {
        const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        const text = label ? label.textContent : input.value;
        if (norm(text) === norm(size)) {
          if (label) label.click(); else { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
          return;
        }
      }
    }
  }
  if (!customElements.get('dtr-size-finder')) customElements.define('dtr-size-finder', SizeFinder);

  class Kit extends HTMLElement {
    connectedCallback() {
      // Re-connects (theme editor section reloads, DOM moves) must not stack listeners.
      this.msg = this.querySelector('[data-kit-msg]');
      if (!this._bound) {
        this._bound = true;
        this.addEventListener('click', (e) => { if (e.target.closest('[data-kit-add]')) this.add(); });
        this.addEventListener('change', () => this.total());
      }
      this.total();
    }
    // Kit total = this product + ticked items (chosen size's price, else base price).
    total() {
      const fmt = (cents) => {
        const cur = window.Shopify?.currency?.active || 'EUR';
        try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(cents / 100); }
        catch { return (cents / 100).toFixed(2); }
      };
      let sum = +this.dataset.mainPrice || 0, ticked = 0;
      for (const row of this.querySelectorAll('.dtr-pdp-kit__row[data-base-price]')) {
        if (!row.querySelector('[data-kit-check]')?.checked) continue;
        const v = row.querySelector('[data-kit-variant]');
        const opt = v && v.tagName === 'SELECT' ? v.selectedOptions[0] : v;
        sum += +(opt?.dataset.price || row.dataset.basePrice || 0);
        ticked++;
      }
      const pct = +this.dataset.saving || 0;
      const save = ticked && pct ? Math.round(sum * pct / 100) : 0;
      const totalEl = this.querySelector('[data-kit-total]');
      if (!totalEl) return; // panel markup not complete (yet): nothing to render into
      totalEl.innerHTML = save ? `<s>${fmt(sum)}</s> ${fmt(sum - save)}` : fmt(sum);
      const saveEl = this.querySelector('[data-kit-save]');
      if (saveEl) saveEl.textContent = save ? (this.dataset.saveLabel || '[amount]').replace('[amount]', fmt(save)) : '';
    }
    // Rows ticked in the list -> cart lines. Returns false (and flags the row) when a size is missing.
    collect(items) {
      for (const row of this.querySelectorAll('.dtr-pdp-kit__row[data-base-price]')) {
        if (!row.querySelector('[data-kit-check]')?.checked) continue;
        const v = row.querySelector('[data-kit-variant]');
        if (!v) continue;
        if (!v.value) { if (this.msg) this.msg.textContent = this.dataset.pickSize; v.focus(); return false; }
        items.push({ id: +v.value, quantity: 1 });
      }
      return true;
    }
    async add() {
      const mainId = document.querySelector(`form#${CSS.escape(this.dataset.form)} [name="id"]`)?.value;
      const items = mainId ? [{ id: +mainId, quantity: 1 }] : [];
      if (!this.collect(items)) return;
      await this.submit(items);
    }
    async submit(items) {
      if (!items.length) { if (this.msg) this.msg.textContent = this.dataset.pickSize; return; }
      const btn = this.querySelector('[data-kit-add]') || document.createElement('span');
      btn.setAttribute('aria-busy', 'true');
      if (this.msg) this.msg.textContent = '';
      try {
        const tv = window.themeVariables || {};
        const addUrl = tv.routes?.cartAddUrl || `${window.Shopify?.routes?.root || '/'}cart/add`;
        const res = await fetch(`${addUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items, sections: 'mini-cart' })
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json.description || json.message);
        if (tv.settings?.cartType === 'page') { window.location.href = `${window.Shopify?.routes?.root || '/'}cart`; return; }
        const cart = await (await fetch(`${tv.routes?.cartUrl || '/cart'}.js`)).json();
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
        cart.sections = json.sections;
        const open = tv.settings?.cartType === 'drawer';
        this.closest('dialog')?.close();
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart, openMiniCart: open } }));
        if (this.msg) this.msg.textContent = this.dataset.added;
      } catch (err) {
        if (this.msg) this.msg.textContent = this.dataset.error; // never the API's own (English) message
      } finally {
        btn.removeAttribute('aria-busy');
      }
    }
  }
  // "Buy the look" panel (sections/dtr-shop-the-look.liquid): same list, sizes and cart call as the kit, no main product.
  class Look extends Kit {
    async add() {
      const items = [];
      if (!this.collect(items)) return;
      await this.submit(items);
    }
  }
  if (!customElements.get('dtr-kit')) customElements.define('dtr-kit', Kit);
  if (!customElements.get('dtr-look')) customElements.define('dtr-look', Look);

  // Carousels (features cards, shop the look): native scroll-snap row (swipe on phones), arrows, progress line.
  const setupCarousel = (root) => {
    if (root._dtrCar) return;
    const row = root.querySelector('[data-dtr-row]');
    if (!row) return;
    root._dtrCar = true;
    const prev = root.querySelector('[data-dtr-prev]'), next = root.querySelector('[data-dtr-next]');
    const bar = root.querySelector('[data-dtr-progress]');
    const update = () => {
      const max = row.scrollWidth - row.clientWidth;
      const rtl = getComputedStyle(row).direction === 'rtl';
      const pos = Math.abs(row.scrollLeft);
      const overflow = max > 2;
      if (prev) { prev.disabled = !overflow || pos <= 2; prev.hidden = !overflow; }
      if (next) { next.disabled = !overflow || pos >= max - 2; next.hidden = !overflow; }
      if (bar) {
        const share = overflow ? row.clientWidth / row.scrollWidth : 1;
        bar.style.width = `${Math.max(share, 0.12) * 100}%`;
        bar.style.marginInlineStart = overflow ? `${(pos / max) * (1 - Math.max(share, 0.12)) * 100}%` : '0';
        bar.parentElement.hidden = !overflow;
      }
      return rtl;
    };
    const step = (dir) => {
      const card = row.firstElementChild;
      const w = card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(row).columnGap) || 0) : row.clientWidth;
      row.scrollBy({ left: dir * w * (getComputedStyle(row).direction === 'rtl' ? -1 : 1), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));
    row.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(row);
    update();
  };
  const carousels = () => document.querySelectorAll('[data-dtr-carousel]').forEach(setupCarousel);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', carousels); else carousels();
  document.addEventListener('shopify:section:load', carousels);

  // Feature card videos play only while on screen (muted, looping); reduced motion keeps the poster frame.
  const cardVideos = () => {
    const vids = document.querySelectorAll('video.dtr-details__video:not([data-io])');
    if (!vids.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) en.target.play().catch(() => {}); else en.target.pause();
    }), { threshold: 0.4 });
    vids.forEach((v) => { v.dataset.io = '1'; io.observe(v); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cardVideos); else cardVideos();
  document.addEventListener('shopify:section:load', cardVideos);

  // Reviews gate: the reviews header (dtr_fit), the Loox carousel (dtr_carousel) and the panel's Reviews tab stay
  // hidden (CSS: html:not(.dtr-rev-ok)) until a Loox widget really has content, i.e. Loox has given one of its
  // iframes/containers a real inline height. If Loox fails (CORS, blocked, no reviews) nothing is ever revealed.
  // The fit-meter section renders [data-dtr-rev-none] when the product has 0 reviews (server side): never reveal then.
  (() => {
    const root = document.documentElement;
    if (root.classList.contains('dtr-rev-ok') || document.querySelector('[data-dtr-rev-none]')) return;
    const SEL = '[id$="__dtr_carousel"] .shopify-app-block, [id$="__dtr_carousel"] .loox-widget, [id$="__dtr_carousel"] iframe, [id$="__dtr_reviews"] .loox-widget, [id$="__dtr_reviews"] iframe';
    const hasContent = () => [...document.querySelectorAll(SEL)].some((el) => (parseFloat(el.style.height) || 0) > 100);
    let mo = null;
    const reveal = () => {
      root.classList.add('dtr-rev-ok');
      document.querySelectorAll('[data-dtr-tab-btn="reviews"]').forEach((b) => { if (reviewsSection()) b.hidden = false; });
      if (mo) mo.disconnect();
    };
    const check = () => { if (hasContent()) { reveal(); return true; } return false; };
    if (check()) return;
    mo = new MutationObserver(check);
    const watch = () => {
      document.querySelectorAll('[id$="__dtr_carousel"], [id$="__dtr_reviews"]').forEach((sec) => {
        mo.observe(sec, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'height'] });
      });
    };
    watch();
    // Loox also posts its content height; re-check on any message from loox.io and a few times after load.
    window.addEventListener('message', (e) => { if (/(^|\.)loox\.io$/.test(String(e.origin).replace(/^https?:\/\//, ''))) setTimeout(check, 50); });
    window.addEventListener('load', () => { watch(); [500, 1500, 4000, 10000].forEach((t) => setTimeout(check, t)); });
  })();

  // Reviews: "Read all reviews" / [data-dtr-reviews] opens the Reviews tab of the shared panel.
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-dtr-reviews]');
    if (!trigger || !reviewsSection() || !document.documentElement.classList.contains('dtr-rev-ok')) return;
    e.preventDefault();
    openPanel('reviews', trigger);
  });

  // Dispatch line: "Ships today" before the cutoff on a working day (Mon-Fri
  // minus the no-dispatch dates, shop time zone). Otherwise "Ships tomorrow"
  // when the next working day is the next calendar day, "Ships Monday" within
  // a week, and the date ("Ships 2 Jan") further out.
  // dispatch:start
  const dispatchKind = (now, tz, cutoff, holidays, locale, weekdays) => {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', hour12: false })
      .formatToParts(now).map((p) => [p.type, p.value]));
    const day = Date.UTC(+parts.year, +parts.month - 1, +parts.day), DAY = 864e5;
    const working = (t) => { const w = new Date(t).getUTCDay(); return w >= 1 && w <= 5 && !holidays.has(new Date(t).toISOString().slice(0, 10)); };
    if (working(day) && +parts.hour % 24 < cutoff) return { kind: 'today' };
    let ahead = 0;
    do { ahead++; } while (!working(day + ahead * DAY) && ahead < 400);
    if (ahead === 1) return { kind: 'tomorrow' };
    if (ahead <= 6 && weekdays && weekdays.length === 7) return { kind: 'later', label: weekdays[new Date(day + ahead * DAY).getUTCDay()].trim() };
    const opts = ahead <= 6 ? { weekday: 'long' } : { day: 'numeric', month: 'short' };
    return { kind: 'later', label: new Intl.DateTimeFormat(locale, { ...opts, timeZone: 'UTC' }).format(new Date(day + ahead * DAY)) };
  };
  // dispatch:end
  const dispatch = () => document.querySelectorAll('[data-dtr-dispatch]').forEach((el) => {
    const holidays = new Set((el.dataset.holidays || '').match(/\d{4}-\d{2}-\d{2}/g) || []);
    const r = dispatchKind(new Date(), el.dataset.tz, +el.dataset.cutoff || 16, holidays, document.documentElement.lang || 'uk', (el.dataset.weekdays || '').split(','));
    el.dataset.done = '1';
    el.textContent = r.kind === 'later' ? el.dataset.later.replace('[day]', r.label) : el.dataset[r.kind];
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dispatch); else dispatch();
  new MutationObserver(() => { if (document.querySelector('[data-dtr-dispatch]:not([data-done])')) dispatch(); }).observe(document.body, { childList: true, subtree: true });
})();
